export const headers = [
  { name: 'Tipo', field: 'dish_type.name', sortable: true },
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Ativo', field: 'is_active', sortable: true },
  { name: 'Cadastrado em', field: 'created_at', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
